import { Address } from '..';


interface AddressDisplayProps {
    address: Address;
}

export function AddressDisplay({
    address: {
        street, city, state, zip
    }
}: AddressDisplayProps) {
    return (
        <>
            {street}<br />

            {/* eslint-disable-next-line react/jsx-newline */}
            {city}, {state} {zip}
        </>
    );
}
